// // get products
// export const getProducts = (products, category, type, limit, product_id) => {
//   let finalProducts = category
//     ? products.filter(
//         (product) => product.category.filter((single) => single === category)[0]
//       )
//     : products;

//   if (product_id) {
//     finalProducts = finalProducts.filter((product) => product.id != product_id);
//   }

//   if (type && type === "new") {
//     const newProducts = finalProducts.filter((single) => single.new);
//     return newProducts.slice(0, limit ? limit : newProducts.length);
//   }

//   if (type && type === "bestSeller") {
//     return finalProducts
//       .sort((a, b) => {
//         return b.saleCount - a.saleCount;
//       })
//       .slice(0, limit ? limit : finalProducts.length);
//   }
//   if (type && type === "saleItems") {
//     const saleItems = finalProducts.filter(
//       (single) => single.discount && single.discount > 0
//     );
//     return saleItems.slice(0, limit ? limit : saleItems.length);
//   }
//   return finalProducts.slice(0, limit ? limit : finalProducts.length);
// };

// // get product discount price
// export const getDiscountPrice = (price, discount) => {
//   return discount && discount > 0 ? price - price * (discount / 100) : null;
// };

// // get product cart quantity
// export const getProductCartQuantity = (cartItems, product, color, size) => {
//   let productInCart = cartItems.find(
//     (single) =>
//       single.id === product.id &&
//       (single.selectedProductColor
//         ? single.selectedProductColor === color
//         : true) &&
//       (single.selectedProductSize ? single.selectedProductSize === size : true)
//   );
//   // if (cartItems.length >= 1 && productInCart) {
//   //   if (product.variation) {
//   //     return cartItems.find(
//   //       single =>
//   //         single.id === product.id &&
//   //         single.selectedProductColor === color &&
//   //         single.selectedProductSize === size
//   //     ).quantity;
//   //   } else {
//   //     return cartItems.find(single => product.id === single.id).quantity;
//   //   }
//   // } else {
//   //   return 0;
//   // }
//   if (cartItems.length >= 1 && productInCart) {
//     if (product.variation) {
//       const matchedItem = cartItems.find(
//         (single) =>
//           single.id === product.id &&
//           single.selectedProductColor === color &&
//           single.selectedProductSize === size
//       );
//       return matchedItem ? matchedItem.quantity : 0;
//     } else {
//       const matchedItem = cartItems.find((single) => product.id === single.id);
//       return matchedItem ? matchedItem.quantity : 0;
//     }
//   }

//   //return 0;
// };

// export const cartItemStock = (item, color, size) => {
//   if (item.stock) {
//     return item.stock;
//   } else {
//     return item.variation;
//     // .filter(single => single.color === color)[0]
//     // .size.filter(single => single.name === size)[0].stock;
//   }
// };

// //get products based on category
// export const getSortedProducts = (products, sortType, sortValue) => {
//   if (products && sortType && sortValue) {
//     if (sortType === "category") {
//       return products.filter(
//         (product) =>
//           product.category.filter((single) => single === sortValue)[0]
//       );
//     }
//     if (sortType === "tag") {
//       return products.filter(
//         (product) => product.tag.filter((single) => single === sortValue)[0]
//       );
//     }
//     if (sortType === "color") {
//       return products.filter(
//         (product) =>
//           product.variation &&
//           product.variation.filter((single) => single.color === sortValue)[0]
//       );
//     }
//     if (sortType === "size") {
//       return products.filter(
//         (product) =>
//           product.variation &&
//           product.variation.filter(
//             (single) =>
//               single.size.filter((single) => single.name === sortValue)[0]
//           )[0]
//       );
//     }
//     if (sortType === "filterSort") {
//       let sortProducts = [...products];
//       if (sortValue === "default") {
//         return sortProducts;
//       }
//       if (sortValue === "priceHighToLow") {
//         return sortProducts.sort((a, b) => {
//           return b.price - a.price;
//         });
//       }
//       if (sortValue === "priceLowToHigh") {
//         return sortProducts.sort((a, b) => {
//           return a.price - b.price;
//         });
//       }
//     }
//   }
//   return products;
// };

// // get individual element
// const getIndividualItemArray = (array) => {
//   let individualItemArray = array.filter(function (v, i, self) {
//     return i === self.indexOf(v);
//   });
//   return individualItemArray;
// };

// // get individual categories
// export const getIndividualCategories = (products) => {
//   let productCategories = [];
//   products &&
//     products.map((product) => {
//       return (
//         product.category &&
//         product.category.map((single) => {
//           return productCategories.push(single);
//         })
//       );
//     });
//   const individualProductCategories = getIndividualItemArray(productCategories);
//   return individualProductCategories;
// };

// // get individual tags
// export const getIndividualTags = (products) => {
//   let productTags = [];
//   products &&
//     products.map((product) => {
//       return (
//         product.tag &&
//         product.tag.map((single) => {
//           return productTags.push(single);
//         })
//       );
//     });
//   const individualProductTags = getIndividualItemArray(productTags);
//   return individualProductTags;
// };

// // get individual colors
// export const getIndividualColors = (products) => {
//   let productColors = [];
//   products &&
//     products.map((product) => {
//       return (
//         product.variation &&
//         product.variation.map((single) => {
//           return productColors.push(single.color);
//         })
//       );
//     });
//   const individualProductColors = getIndividualItemArray(productColors);
//   return individualProductColors;
// };

// // get individual sizes
// export const getProductsIndividualSizes = (products) => {
//   let productSizes = [];
//   products &&
//     products.map((product) => {
//       return (
//         product.variation &&
//         product.variation.map((single) => {
//           return single.size.map((single) => {
//             return productSizes.push(single.name);
//           });
//         })
//       );
//     });
//   const individualProductSizes = getIndividualItemArray(productSizes);
//   return individualProductSizes;
// };

// // get product individual sizes
// export const getIndividualSizes = (product) => {
//   let productSizes = [];
//   product.variation &&
//     product.variation.map((singleVariation) => {
//       return (
//         singleVariation.size &&
//         singleVariation.size.map((singleSize) => {
//           return productSizes.push(singleSize.name);
//         })
//       );
//     });
//   const individualSizes = getIndividualItemArray(productSizes);
//   return individualSizes;
// };

// // export const setActiveSort = e => {
// //   const filterButtons = document.querySelectorAll(
// //     ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
// //   );
// //   filterButtons.forEach(item => {
// //     item.classList.remove("active");
// //   });
// //   e.currentTarget.classList.add("active");
// // };

// export const setActiveSort = (e) => {
//   const filterButtons = document.querySelectorAll(
//     ".sidebar-widget-list-left button, .sidebar-widget-tag button, .product-filter button"
//   );
//   const clickedButton = e.currentTarget;
//   // If clicked button is already active, remove 'active' and exit
//   if (clickedButton.classList.contains("active")) {
//     clickedButton.classList.remove("active");
//     return;
//   }
//   // Otherwise, remove 'active' from all buttons and add to clicked one
//   filterButtons.forEach((item) => {
//     item.classList.remove("active");
//   });
//   clickedButton.classList.add("active");
// };
// export const setActiveLayout = (e) => {
//   const gridSwitchBtn = document.querySelectorAll(".shop-tab button");
//   gridSwitchBtn.forEach((item) => {
//     item.classList.remove("active");
//   });
//   e.currentTarget.classList.add("active");
// };

// export const toggleShopTopFilter = (e) => {
//   const shopTopFilterWrapper = document.querySelector(
//     "#product-filter-wrapper"
//   );
//   shopTopFilterWrapper.classList.toggle("active");
//   if (shopTopFilterWrapper.style.height) {
//     shopTopFilterWrapper.style.height = null;
//   } else {
//     shopTopFilterWrapper.style.height =
//       shopTopFilterWrapper.scrollHeight + "px";
//   }
//   e.currentTarget.classList.toggle("active");
// };


export const getProducts = (products, category, type, limit, customIds) => {
  let finalProducts = [];
  // Filter by specific product IDs if customIds are provided
  if (Array.isArray(customIds) && customIds.length > 0) {
    finalProducts = products.filter(product => customIds.includes(product.id));
  } else if (category) {
    if (Array.isArray(category)) {
      finalProducts = products.filter(product =>
        product.category?.some(cat => category.includes(cat))
      );
    } else {
      finalProducts = products.filter(product =>
        product.category?.includes(category)
      );
    }
  } else {
    finalProducts = products;
  }
  // Type-based filtering
  if (type === "new") {
    const newProducts = finalProducts.filter(single => single.new);
    return newProducts.slice(0, limit ?? newProducts.length);
  }
  if (type === "bestSeller") {
    return finalProducts
      .sort((a, b) => b.saleCount - a.saleCount)
      .slice(0, limit ?? finalProducts.length);
  }
  if (type === "saleItems") {
    const saleItems = finalProducts.filter(single => single.discount > 0);
    return saleItems.slice(0, limit ?? saleItems.length);
  }
  return finalProducts.slice(0, limit ?? finalProducts.length);
};
// Calculate discount price
export const getDiscountPrice = (price, discount) => {
  if (discount && discount > 0) {
    return price - price * (discount / 100);
  }
  return null;
};
// Get product cart quantity based on color and size
export const getProductCartQuantity = (
  cartItems,
  product,
  selectedProductColor,
  selectedProductSize
) => {
  let productInCart = cartItems.find(
    item =>
      item.id === product.id &&
      item.selectedProductColor === selectedProductColor &&
      item.selectedProductSize === selectedProductSize
  );
  return productInCart ? productInCart.quantity : 0;
};
// Get stock of specific cart item variant
export const cartItemStock = (item, color, size) => {
  if (item.variation) {
    const variation = item.variation.find(v => v.color === color);
    if (variation) {
      const sizeObject = variation.size.find(s => s.name === size);
      return sizeObject ? sizeObject.stock : 0;
    }
    return 0;
  }
  return item.stock;
};
// Get all filtered products
// Get individual categories from all products
export const getIndividualCategories = products => {
  const categories = products
    .map(product => product.category)
    .flat()
    .filter(Boolean);
  return [...new Set(categories)];
};
// Get individual colors from all products
export const getIndividualColors = products => {
  let colors = [];
  products.forEach(product => {
    if (product.variation) {
      product.variation.forEach(variant => {
        if (variant.color) colors.push(variant.color);
      });
    }
  });
  return [...new Set(colors)];
};
// Get individual sizes from all products
export const getProductsIndividualSizes = products => {
  let sizes = [];
  products.forEach(product => {
    if (product.variation) {
      product.variation.forEach(variant => {
        variant.size.forEach(size => {
          sizes.push(size.name);
        });
      });
    }
  });
  return [...new Set(sizes)];
};
// Get individual tags from all products
export const getIndividualTags = products => {
  let tags = [];
  products.forEach(product => {
    if (product.tags) {
      tags = [...tags, ...product.tags];
    }
  });
  return [...new Set(tags)];
};
// Sort products based on criteria
export const getSortedProducts = (products, sortType, sortValue) => {
  if (!products || !sortType || !sortValue) return products;
  if (sortType === "category") {
    return products.filter(product =>
      product.category?.includes(sortValue)
    );
  }
  if (sortType === "tag") {
    return products.filter(product =>
      product.tags?.includes(sortValue)
    );
  }
  if (sortType === "color") {
    return products.filter(product =>
      product.variation?.some(v => v.color === sortValue)
    );
  }
  if (sortType === "size") {
    return products.filter(product =>
      product.variation?.some(v =>
        v.size.some(s => s.name === sortValue)
      )
    );
  }
  if (sortType === "filterSort") {
    switch (sortValue) {
      case "default":
        return [...products];
      case "priceHighToLow":
        return [...products].sort((a, b) => b.price - a.price);
      case "priceLowToHigh":
        return [...products].sort((a, b) => a.price - b.price);
      default:
        return [...products];
    }
  }
  return products;
};
// Toggle filter visibility (used in some shop pages)
export const toggleShopTopFilter = () => {
  const filterEl = document.querySelector(".shop-top-bar-wrapper");
  if (filterEl) {
    filterEl.classList.toggle("active");
  }
};
// Set active layout (used in shop view toggles)
export const setActiveLayout = layout => {
  const gridWrappers = document.querySelectorAll(".shop-product-wrap");
  gridWrappers.forEach(wrapper => {
    wrapper.classList.remove("grid", "list", "grid-three-column");
    wrapper.classList.add(layout);
  });
};
// Set active sort (used in sorting dropdown)
export const setActiveSort = e => {
  const allOptions = document.querySelectorAll(".sort-type li");
  allOptions.forEach(option => option.classList.remove("active"));
  e.currentTarget.classList.add("active");
};